module.exports = __webpack_public_path__ + "img/2.76f40c2d.png";